import React from 'react';
import { useTranslation } from 'react-i18next';
import { featuresData, TitleIcon } from '../constants.tsx';

const Features: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="features" className="overflow-hidden pt-16 lg:pt-20 xl:pt-24 scroll-mt-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 xl:px-0">
        <div className="text-center">
          <span className="hero-subtitle-gradient relative mb-4 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
            <TitleIcon />
            <span className="hero-subtitle-text"> {t('featuresSectionSubtitle')} </span>
          </span>
          <h2 className="text-white mb-4.5 text-2xl font-extrabold sm:text-4xl">
            {t('featuresSectionTitle')}
          </h2>
          <p className="max-w-3xl mx-auto mb-5 font-medium">
            {t('featuresSectionDescription')}
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-[1px] features-row-border"></div>
          <div className="hidden lg:block absolute top-0 left-1/2 w-[1px] h-full features-row-border" style={{ transform: 'rotate(90deg)' }}></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            {featuresData.slice(0, 3).map((feature, index) => (
              <div key={index} className="relative overflow-hidden text-center p-8">
                <div className="relative z-10">
                  <span className="feature-icon-container relative w-20 h-20 rounded-2xl inline-flex items-center justify-center mb-8 mx-auto">
                    {feature.icon}
                  </span>
                  <h4 className="font-semibold text-lg text-white mb-4">{t(feature.titleKey)}</h4>
                  <p className="font-medium">{t(feature.descriptionKey)}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="w-full h-[1px] features-row-border"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            {featuresData.slice(3, 6).map((feature, index) => (
              <div key={index} className="relative overflow-hidden text-center p-8">
                <div className="relative z-10">
                   <span className="feature-icon-container relative w-20 h-20 rounded-2xl inline-flex items-center justify-center mb-8 mx-auto">
                    {feature.icon}
                  </span>
                  <h4 className="font-semibold text-lg text-white mb-4">{t(feature.titleKey)}</h4>
                  <p className="font-medium">{t(feature.descriptionKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;